module.exports = __webpack_public_path__ + "img/sz_nav_bj.6d6a66b2.png";